import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Button, TextField, Grid, Box, Typography, Paper } from "@mui/material";
import ForgotPasswordService from "../../services/forgotPassword";
import { useNotificationContext } from "../../common/NotificationContext";
import { useLoading } from "../../common/LoadingContext";
import logo from "../../assets/img/logo.png";
import { useNavigate } from "react-router-dom";
import { Lock } from "@material-ui/icons";
import CheckerComponent from "../../common/CheckerComponent";
import {
  confirmMatchedPassword,
  containSpecialCharacters,
  hasLowerCase,
  hasNumber,
  hasUpperCase,
  lengthGreaterThan,
} from "../../utils/jsUtils";
import { yupResolver } from "@hookform/resolvers/yup";
import { VERIFY_TOKEN_PASSWORD } from "../../utils/Validation";
import VerifyTokenAndPassword from "./VerifyTokenAndPassword";
import { getCaptchCodeImgForgotPassword } from "../../services/captchservice";
import CaptchaCheck from "./CaptchaCheck";

const baseUrl = process.env.REACT_APP_BASE_URL;

const ForgotPassword = () => {
  const navigate = useNavigate();

  const { showNotification, enableNotification } = useNotificationContext();
  const [emailPassed, setEmailPassed] = useState(false);
  const [attemptsExhausted, setAttemptsExhausted] = useState(false);
  const [captchaCheck, setCapchaCheck] = useState(false);
  const [resObj, setresObj] = useState({
    captchaId: "",
    captcha_txt: "",
    fileName: "",
  });
  const [captchImg, setCaptchImg] = useState(null);
  const [currentUserId, setCurrentUserId] = useState(null);
  const { setLoading } = useLoading();
  const form1Option = {
    resolver: yupResolver(VERIFY_TOKEN_PASSWORD),
  };
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
    clearErrors,
  } = useForm();
  const {
    register: register1,

    handleSubmit: handleSubmit1,
    formState: { errors: error1 },
    watch: watch1,
  } = useForm(form1Option);

  const onSubmit = async (data) => {
    const param = {
      userId: data.userId,
      text: resObj.captcha_txt,
      fileName: resObj.fileName,
    };
    try {
      setLoading(true);
      enableNotification();

      const forgotPasswordResponse = await ForgotPasswordService(
        baseUrl,
        param
      );
      if (forgotPasswordResponse?.messageCode === 6) {
        setCurrentUserId(data?.userId);

        reset({ userId: "" });
        clearErrors();
        showNotification(
          "Success",
          forgotPasswordResponse?.message ??
            "Confirmation Code Sent to Registered Email Id",
          "success"
        );
        setEmailPassed(true);
      } else {
        setresObj({ ...resObj, captcha_txt: "" });
        showNotification(
          "Error",
          forgotPasswordResponse?.message ?? "Failed to Reset Password"
        );
      }
    } catch (e) {
      showNotification("Error", e?.message ?? "Failed to Reset Password");
    } finally {
      setLoading(false);
    }
  };

  const onReloadCaptch = async (userId = currentUserId) => {
    try {
      setAttemptsExhausted(false);
      setLoading(true);
      const requestBody = {
        captchaId: resObj.captchaId,
        userId: userId,
      };

      const refreshCaptchResponse = await getCaptchCodeImgForgotPassword(
        baseUrl,
        requestBody
      );
      if (
        refreshCaptchResponse.messageCode === 6 &&
        refreshCaptchResponse?.messageType === "SUCCESS"
      ) {
        setCaptchImg(refreshCaptchResponse?.text);
        setresObj({
          ...resObj,
          captcha_txt: "",
          fileName: refreshCaptchResponse?.fileName,
        });
      } else if (refreshCaptchResponse.messageCode === 2) {
        setAttemptsExhausted(true);
        setCaptchImg("");
        setresObj({
          captcha_txt: "",
          captchaId: "",
          fileName: "",
        });
        showNotification(
          "Error",
          refreshCaptchResponse?.message ?? "Failed To Reload Captcha"
        );
      } else {
        setCaptchImg("");
        showNotification(
          "Error",
          refreshCaptchResponse?.message ?? "Failed To Reload Captcha"
        );
      }
    } catch (err) {
      showNotification("Error", err?.message ?? "Failed To Reload Captcha");
    } finally {
      setLoading(false);
    }
  };

  const ForgotPasswordHide = () => {
    navigate("/");
  };
  const getCapImage = async (userId = currentUserId) => {
    let requestObj = {
      userId: userId,
    };

    try {
      setAttemptsExhausted(false);
      setLoading(true);
      const captchTextResponse = await getCaptchCodeImgForgotPassword(
        baseUrl,
        requestObj
      );
      if (captchTextResponse?.messageCode === 6) {
        setCaptchImg(captchTextResponse?.text);
        setresObj({
          ...resObj,
          captchaId: captchTextResponse?.captchaId,
          fileName: captchTextResponse?.fileName,
        });
      } else if (captchTextResponse.messageCode === 2) {
        setAttemptsExhausted(true);
        setCaptchImg("");
        setresObj({
          captcha_txt: "",
          captchaId: "",
          fileName: "",
        });
        showNotification(
          "Error",
          captchTextResponse?.message ?? "Failed To Reload Captcha"
        );
      } else {
        showNotification(
          "Error",
          captchTextResponse?.message ?? "Failed to load"
        );
      }
    } catch (err) {
      showNotification("Error", err?.message ?? "Failed to load");
    } finally {
      setLoading(false);
    }
  };

  const generateCaptcha = async (data) => {
    setCurrentUserId(data?.userId);
    await getCapImage(data?.userId);
    setCapchaCheck(true);
  };

  return (
    <>
      <Paper elevation={3}>
        <Grid container sx={{ background: "#fff", height: "100vh" }}>
          <Grid
            item
            xs={6}
            md={6}
            sx={{
              background:
                "linear-gradient( 40deg, rgba(67, 138, 243, 0.7), rgba(255, 242, 166, 0.7) )",
            }}
          >
            <Box p={4} mt={8}>
              <div className="logoContainer mb20">
                <img src={logo} alt="Logo" />
                <div className="projectLogo">
                  <div title="Dock Appointment">DAS</div>
                  <div className="projectTitle">Dock Appointment System</div>
                </div>
              </div>
            </Box>
            <Typography
              variant="h3"
              color="primary"
              fontWeight={400}
              sx={{ mt: "3", mb: 3 }}
            >
              Welcome Back!
            </Typography>
            {emailPassed ? (
              <>
                <Box
                  alignContent={"center"}
                  sx={{ my: 3, pt: 0, mt: 0, display: "inline-grid" }}
                >
                  <Box display={"flex"} alignItems="center" mt={8}>
                    <Lock
                      fontSize={"medium"}
                      sx={{ color: "primary", mr: 1 }}
                    />
                    <Typography
                      fontSize={"22px"}
                      variant={"body1"}
                      textAlign="center"
                      fontWeight={"600"}
                      color={"primary"}
                    >
                      Password Composition -
                    </Typography>
                  </Box>

                  <Box ml={1} alignContent={"center"}>
                    <CheckerComponent
                      className="font13"
                      label={"Contains at least 8 characters."}
                      isCheck={lengthGreaterThan(8, watch1("password", ""))}
                    ></CheckerComponent>
                    <CheckerComponent
                      className="font13"
                      label={"Contains uppercase characters."}
                      isCheck={hasUpperCase(watch1("password", ""))}
                    ></CheckerComponent>
                    <CheckerComponent
                      className="font13"
                      label={"Contains lowercase characters."}
                      isCheck={hasLowerCase(watch1("password", ""))}
                    ></CheckerComponent>
                    <CheckerComponent
                      className="font13"
                      label={"Contains numerical characters."}
                      isCheck={hasNumber(watch1("password", ""))}
                    ></CheckerComponent>
                    <CheckerComponent
                      className="font13"
                      label={"Contains special characters."}
                      isCheck={containSpecialCharacters(watch1("password", ""))}
                    ></CheckerComponent>
                    <CheckerComponent
                      className="font13"
                      label={"Password must match."}
                      isCheck={confirmMatchedPassword(
                        watch1("confirm_password", ""),
                        watch1("password", "")
                      )}
                    ></CheckerComponent>
                  </Box>
                </Box>
              </>
            ) : (
              <Typography
                color="primary"
                sx={{ my: 3, pt: 2, fontSize: "20px" }}
              >
                To keep connected with us <br />
                please login with your personal info
              </Typography>
            )}

            <Box sx={{ mb: 3, ml: 4 }}></Box>
          </Grid>

          <Grid item xs={6} md={6} sx={{ p: 4, mt: 8 }}>
            <div className="pageHeader" style={{ fontSize: "28px" }}>
              Forgot Password
            </div>

            <Box sx={{ mt: 7 }}>
              {emailPassed ? (
                <>
                  <VerifyTokenAndPassword
                    register={register1}
                    errors={error1}
                    currentUserId={currentUserId}
                    handleSubmit={handleSubmit1}
                    setEmailPassed={setEmailPassed}
                  />
                </>
              ) : (
                <>
                  <Grid item xs={12}>
                    <TextField
                      margin="normal"
                      required
                      type="text"
                      fullWidth
                      label="UserId"
                      name="userId"
                      autoComplete="off"
                      {...register("userId", {
                        required: "UserId is required.",
                      })}
                      disabled={captchaCheck}
                      error={Boolean(errors?.userId)}
                      helperText={errors?.userId?.message}
                    />

                    {captchaCheck && (
                      <CaptchaCheck
                        setresObj={setresObj}
                        resObj={resObj}
                        register={register}
                        captchImg={captchImg}
                        onReloadCaptch={onReloadCaptch}
                        currentUserId={currentUserId}
                        getCapImage={getCapImage}
                        attemptsExhausted={attemptsExhausted}
                      />
                    )}

                    <Button
                      type="button"
                      variant="outlined"
                      sx={{ mt: 3, mb: 2, mr: 2 }}
                      onClick={() => ForgotPasswordHide()}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="button"
                      variant="contained"
                      sx={{ mt: 3, mb: 2 }}
                      disabled={
                        captchaCheck ? resObj?.captcha_txt?.length === 0 : false
                      }
                      onClick={
                        captchaCheck
                          ? handleSubmit(onSubmit)
                          : handleSubmit(generateCaptcha)
                      }
                    >
                      Submit
                    </Button>
                  </Grid>
                </>
              )}
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default ForgotPassword;
